import React from 'react';
import ButtonAction from './ButtonAction';
import LoadableIcon from './LoadableIcon';
import { Input, InputGroup, Button, ButtonGroup } from 'reactstrap';
import * as warnings from '../constants/ValidationWarnings';
import { newId, getLimitedText } from '../helpers/GenericHelpers';

export default class EditableField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.inititalProps();
  }

  inititalProps() {
    return {
      editing: this.props.editing,
      loading: false,
      text: this.props.text || '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.loading) {
      this.setState({
        editing: false,
        loading: false
      });
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSubmit();
    }
  }

  toggle = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({ editing: !this.state.editing });
  }

  getTextLimit() {
    return this.props.limit || 40;
  }

  handleSubmit = () => {
    const submitted = this.props.submit();
    switch (submitted) {
      case 'submit':
        this.setState({ loading: true });
        break;
      case 'clear':
        this.setState({ editing: false });
        break;
      default:
        return;
    }
  }

  getText = () => getLimitedText(this.props.text, this.getTextLimit()) || <span className="empty-field">[empty]</span>

  render() {
    return (<div>
      {this.state.editing?
        <div className="editable-group">
          <div onKeyDown={this.handleKeyPress}>
            {this.props.children}
          </div>
          <ButtonGroup size='sm'>
            <Button
              type="submit"
              icon="fa-check"
              color={this.state.loading ? 'secondary' : 'primary'}
              title={`update ${this.props.itemRef}`}
              onClick={this.handleSubmit}
              disabled={this.props.submitDisabled}
            >
              <LoadableIcon
                loading={this.state.loading}
                icon='fa-check'
              />
            </Button>
            <ButtonAction
              type="button"
              icon="fa-remove"
              color="danger"
              title='clear edits'
              disabled={this.props.clearDisabled}
              action={this.toggle}
            />
          </ButtonGroup>
        </div>
        :
        <div className="editable-group">
          <span className="editable-field">
            <a
              id={this.state.popoverId}
              onClick={this.toggle}
              className="editable-link"
            >{this.getText()}</a>
          </span>
          <ButtonGroup size='sm'>
            <ButtonAction
              type="button"
              icon="fa-pencil"
              color="secondary"
              className='btn-edit'
              title={`edit ${this.props.itemRef}`}
              action={this.toggle}
            />
          </ButtonGroup>
        </div>
      }
    </div>);
  }
}
